import { parsePercent, verticalAlignToFlex } from "./editorFieldUtils";

const alignToFlex = (align) => {
  if (align === "center") {
    return "center";
  }
  if (align === "right") {
    return "flex-end";
  }
  return "flex-start";
};

/** Flex container for image/button inside the cell (canvas). */
export const contentLayoutWrapperSx = (props) => ({
  width: "100%",
  height: "100%",
  minHeight: "100%",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  alignItems: alignToFlex(props?.contentAlign || props?.align || "center"),
  justifyContent: verticalAlignToFlex(props?.contentVAlign || "center"),
});

export const imageWidthStyle = (props) => {
  const fixedWidth = Number(props?.fixedWidthPx) || 0;
  const fixedHeight = Number(props?.fixedHeightPx) || 0;
  if (fixedWidth > 0 || fixedHeight > 0) {
    return {
      width: fixedWidth > 0 ? `${fixedWidth}px` : "auto",
      height: fixedHeight > 0 ? `${fixedHeight}px` : "auto",
      maxWidth: "100%",
      objectFit: fixedWidth > 0 && fixedHeight > 0 ? "cover" : "contain",
    };
  }
  const percent =
    props?.widthPercent !== undefined && props?.widthPercent !== null
      ? props.widthPercent
      : parsePercent(props?.width, 100);
  return { width: `${percent}%`, maxWidth: "100%", height: "auto" };
};

/** Horizontal alignment for block images (matches exported HTML margin rules). */
export const imageAlignMarginSx = (props) => {
  const align = props?.contentAlign || props?.align || "center";
  if (align === "center") {
    return { marginLeft: "auto", marginRight: "auto" };
  }
  if (align === "right") {
    return { marginLeft: "auto", marginRight: 0 };
  }
  return { marginLeft: 0, marginRight: "auto" };
};

const imageMarginCss = (align) => {
  if (align === "center") {
    return "margin-left:auto;margin-right:auto;";
  }
  if (align === "right") {
    return "margin-left:auto;";
  }
  return "";
};

/**
 * Email-safe alignment wrapper (table cell) so vertical/horizontal position matches preview.
 */
export const alignContentWrapHtml = (props, innerHtml) => {
  const align = props?.contentAlign || props?.align || "center";
  const vAlign = props?.contentVAlign || "center";
  const valign = vAlign === "top" ? "top" : vAlign === "bottom" ? "bottom" : "middle";
  return `<table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="width:100%;border-collapse:collapse;"><tr><td align="${align}" valign="${valign}" style="text-align:${align};vertical-align:${valign};font-size:14px;line-height:1.5;">${innerHtml}</td></tr></table>`;
};

export const buildImageInlineStyle = (props) => {
  const align = props?.contentAlign || props?.align || "center";
  const fixedWidth = Number(props?.fixedWidthPx) || 0;
  const fixedHeight = Number(props?.fixedHeightPx) || 0;
  if (fixedWidth > 0 || fixedHeight > 0) {
    return [
      "display:block",
      fixedWidth > 0 ? `width:${fixedWidth}px` : "width:auto",
      fixedHeight > 0 ? `height:${fixedHeight}px` : "height:auto",
      "max-width:100%",
      fixedWidth > 0 && fixedHeight > 0 ? "object-fit:cover" : "object-fit:contain",
      "box-sizing:border-box",
      imageMarginCss(align),
    ]
      .filter(Boolean)
      .join(";");
  }
  const widthPercent = props?.widthPercent ?? 100;
  return [
    "display:block",
    `width:${widthPercent}%`,
    "max-width:100%",
    "height:auto",
    "box-sizing:border-box",
    imageMarginCss(align),
  ]
    .filter(Boolean)
    .join(";");
};

export const buttonSizeStyle = (props) => {
  const widthPercent = props?.buttonWidthPercent ?? 0;
  const paddingX = props?.buttonPaddingX ?? 24;
  const paddingY = props?.buttonPaddingY ?? 12;
  return {
    display: "inline-block",
    maxWidth: "100%",
    width: widthPercent > 0 ? `${widthPercent}%` : "auto",
    padding: `${paddingY}px ${paddingX}px`,
    boxSizing: "border-box",
  };
  };

 